import React from 'react';
import { Instrument } from '../../../hooks/mapInstruments';
import { AbroadBankForm } from '../AbroadBankForm';

export const Content: React.FC<Instrument> = (props) => {
  switch (props.currency) {
    case 'USD':
      return <AbroadBankForm {...props} />;
    default:
      return <>{props.currency} bank witdraw is under construction</>;
  }
};
